<template>
  <div id="dialog-buy-tokens">
    <v-dialog v-model="modalBuyTokens.dialog" persistent max-width="600px">
      <v-card>
        <v-list-item class="grey lighten-2">
          <v-list-item-content>
            <v-list-item-title class="headline font-weight-bold text-h4">
              Buy Tokens
            </v-list-item-title>
          </v-list-item-content>
          <v-btn
            icon
            @click="hideBuyTokensDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>
        <v-card-text v-for="(item, i) in TokenPackages" :key="i">
          <v-row>
            <v-col class="mb-0 pb-0 font-weight-bold text-h6 text-md-h5" cols="12" sm="8" md="10">
              <p>
                {{ item.description }}
              </p>
              <p>
                For: <span class="price primary--text">{{ toMoney(item.price) }}</span>
              </p>
            </v-col>
            <v-col class="text-right" cols="12" sm="4" md="2">
              <v-btn
                :block="$vuetify.breakpoint.xs"
                large
                :disabled="loading"
                dark
                color="primary"
                v-on:click="confirm(item.price)"
              >
                Buy
              </v-btn>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-btn large @click="hideBuyTokensDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import utils from "@/utils/utils.js";
export default {
  data: () => {
    return {
      loading: false,
    };
  },
  computed: mapState(["modalBuyTokens", "TokenPackages"]),
  methods: {
    ...mapActions(["hideBuyTokensDialog"]),
    toMoney(price) {
      return utils.toMoney(price);
    },
    confirm(price) {
      this.$store.dispatch("showDialog", {
        price,
        title: "Confirm your order...",
        message: `Please be advised by clicking on buy below you're agreeing to our terms and conditions; and authorizing Pjili to charge your default credit card the amount of ${utils.toMoney(
          price
        )}.`,
      });
    },
    buy() {
      this.loading = true;
      this.$axios
        .get(this.$cfg.ACCOUNTS_API_URL + "health")
        .then(() => {
          this.hideBuyTokensDialog();
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.dispatch("addNotification", {
              type: "error",
              message:
                "We're really sorry our systems seems to be unhealty now. Please try again later or contact us.",
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>

</style>